import { clampBlueprintOpacity } from '@shared/helpers/design/blueprint-underlay.helpers';
import type { BlueprintUnderlay } from '@shared/models/design/blueprint-underlay.model';

/** Unsaved opacity while the Properties slider is being dragged. */
export type BlueprintOpacityPreview = {
  underlayId: string;
  opacity: number;
};

/**
 * Overlay a slider drag onto the underlay the map draws.
 * Other pages, and an unchanged opacity, keep the same object.
 */
export const applyBlueprintOpacityPreview = (
  underlay: BlueprintUnderlay | undefined,
  preview: BlueprintOpacityPreview | undefined,
): BlueprintUnderlay | undefined => {
  if (!underlay || !preview || preview.underlayId !== underlay.id) {
    return underlay;
  }
  const opacity = clampBlueprintOpacity(preview.opacity);
  if (opacity === underlay.opacity) return underlay;
  return { ...underlay, opacity };
};
